import { /* doFetch as  */doXhr } from '../../../remote/request.js';
import AjaxEntity from './base.js';

/**
 * @typedef {{ product_id: number|string; variant_id?: number|string; qty: number; }} MpApiCartAddItem
 * @typedef {{ product_id: number|string; variant_id?: number|string; qty: number; }} MpApiCartModifyItem
 * @typedef {{ items: MpApiCartAddItem[]; }} MpApiCartAddData
 *
 * @typedef {{ cart_id: number|string; qty: number; }} MpApiCartUpdateItem
 * @typedef {{ items: MpApiCartUpdateItem[]; }} MpApiCartUpdateData
 * @typedef {{ items: MpApiCartModifyItem[]; }} MpApiCartModifyData
 *
 * @typedef {{ cart_id: number; cart_type: string; qty: number; product_id: number; id: number; sku?: string; name: string; description?: string; url?: string; }} MpApiCartResponseItem
 * @typedef {{ items: MpApiCartResponseItem[], subtotal: number; total_amount: number; count_items: number; }} MpApiCartResponseData
 * @typedef {{ status: number; error?: string; message?: string; data?: MpApiCartResponseData }} MpApiCartResponse
 * @typedef {{ payment_code: string; amount: number; currency: string; description: string; success_url: string; failure_url: string, order: object, errors?: object }} MpApiPayResponse
 */

export default class Cart extends AjaxEntity {

	static get NAME() {
		return 'Cart';
	}

	constructor() {
		super();
	}

	get() {
		return doXhr(this.endpoints.get);
	}

	/**
	 * @param {MpApiCartAddData} data
	 *
	 * @returns {Promise<MpApiCartResponse>}
	 */
	add(data) {
		return doXhr(this.endpoints.add, { method: 'POST', data });
	}

	/**
	 * @param {MpApiCartUpdateData} data
	 *
	 * @returns {Promise<MpApiCartResponse>}
	 */
	update(data) {
		return doXhr(this.endpoints.update, { method: 'POST', data });
	}

	/**
	 * @param {MpApiCartModifyData} data
	 *
	 * @returns {Promise<MpApiCartResponse>}
	 */
	modify(data) {
		return doXhr(this.endpoints.modify, { method: 'POST', data });
	}

	addCoupon(data) {
		return doXhr(this.endpoints.addCoupon, { method: 'POST', data });
	}

	deleteCoupon() {
		return doXhr(this.endpoints.deleteCoupon, { method: 'POST' });
	}

	setUserData(data) {
		return doXhr(this.endpoints.setUserData, { method: 'POST', data });
	}

	setShippingMethod(data) {
		return doXhr(this.endpoints.setShippingMethod, { method: 'POST', data });
	}

	setPaymentMethod(data) {
		return doXhr(this.endpoints.setPaymentMethod, { method: 'POST', data });
	}

	clear() {
		return doXhr(this.endpoints.clear, { method: 'POST' });
	}

	checkout(data) {
		return doXhr(this.endpoints.checkout, { method: 'POST', data });
	}

	processOrder(data) {
		return doXhr(this.endpoints.processOrder, { method: 'POST', data });
	}
}
